import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import '../inputs.scss';

const EmailInput = ({
    title = 'e-mail',
    hasError = false,
    onBlur = () => {},
    errorText = '',
    value,
    onChange,
}) => {
    const inputClasses = classNames({
        input: true,
        'has-error': hasError,
    });

    return (
        <label htmlFor="email" styleName="input--has-float-label input-error-container">
            <input
                styleName={inputClasses}
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                value={value}
                onChange={onChange}
                onBlur={onBlur}
            />

            <div styleName="input__label">{title}</div>
            {hasError && <div styleName="input-error">{errorText}</div>}
        </label>
    );
};

export default EmailInput;

EmailInput.propTypes = {
    title: PropTypes.string,
    value: PropTypes.string.isRequired,
    hasError: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    errorText: PropTypes.string,
};
